import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApi, BASE_URL, User } from '@edl-development/edl-common';
import { BaseUserRoleDTO } from '../model/base/base-user-role-dto.model';
import { BaseUserDTO } from '../model/base/base-user-dto.model';

@Injectable()
export class PaetepUserApi extends BaseApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getSupervisors(userId: string) {
        return this.http.get<BaseUserDTO[]>(this.baseUri + '/user/' + userId + '/supervisors', {});
    }

    getUserRolesByPriority(userId: string) {
        return this.http.get<BaseUserRoleDTO[]>(`${this.baseUri}/user/${userId}/userRolesByPriority`, {});
    }

    getSupervisorsForBuilding  (buildingId: number) {
      return this.http.post<BaseUserDTO[]>(`${this.baseUri}/user/supervisorsForBuilding`, buildingId);
    }
}
